import { Select, Space } from 'antd';
import React, { useCallback } from 'react'
import { INaturalForestWithClashData } from '../../NaturalForestsContextContainer';
import { useTranslation } from 'react-i18next';
const { Option } = Select;

type Props = {
    naturalForest: INaturalForestWithClashData
}

export default function NaturalForestOption(props: Props) {
    const { t } = useTranslation('naturalForests');

    const mapStatusToText = useCallback((status: number): string => {
        switch (status) {
            case 1:
                return "";
            case 2:
                return t("metsäJossaIlmoituksia");
            case 3:
                return t("metsäJokaHakattu");
            default:
                return "2";
        }
    }, []);

    return (
        <div style={{ "display": "flex", "justifyContent": "space-between" }}>
            <span>{props.naturalForest.properties.name}</span>
            <span>{mapStatusToText(props.naturalForest.properties.status)}</span>
        </div>

    )
}